export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.737 13.323a1 1 0 01-1.32 1.497l-.094-.083-6.53-6.53a1 1 0 01-.084-1.32l.084-.094 6.5-6.5a1 1 0 011.497 1.32l-.083.094L2.915 7.5l5.822 5.823z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "10",
    "height": "16",
    "viewBox": "0 0 10 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};